import DateFns from "./DateFns";
import { v4 as uuidv4 } from 'uuid';
import { FR_HEADER } from "src/const/const-from-env";

export const convertParamsToObject = (stringParams: string) => {
  const urlParams = new URLSearchParams(stringParams);
  const entries = urlParams.entries();
  function paramsToObject(entries) {
    const result = {};
    for (const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }
  const params = paramsToObject(entries);
  return params;
};

export const covertParamsStringJsonToObject = (search) => {
  const searchPr = search.substring(1)
  const decode = decodeURIComponent(searchPr)
  const result = JSON.parse(decode)
  return result
}
export const removePunctuations = (str: string) => {
  str = str?.replace(
    /!@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " "
  );
  return str;
};
export const specialCharacter = '[`!@#$%^&*()_+-=[]{};\':"\\|,.<>/?~]/'

export const createMSGID = (frSystm: string) => {
  return `${frSystm || FR_HEADER}-${DateFns.format(new Date(), 'yyMMdd ').trim()}-${uuidv4()}`
}
export const createCreDtTm = () => {
  return `${DateFns.format(new Date(), 'dd/MM/yyyy hhmmss')}`
}

export function numberWithCommas(x) {
  x = x?.toString();
  let pattern = /(-?\d+)(\d{3})/;
  while (pattern?.test(x))
      x = x?.replace(pattern, "$1,$2");
  return x;
}